import axios from '../../utils/axiosConfig';
import { Contexture } from '../Contexture/Contexture';

const BASE_URL = `${process.env.REACT_APP_LAMBDA_API_URL}/application/profiles`;

export class UserProfiles {
  static async fetchAll(params) {
    try {
      const response = await axios.get(`${BASE_URL}`, {
        headers: Contexture.getHeaders(),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async fetchByUserId(userId, params) {
    try {
      if (!userId || userId.trim().length === 0) {
        throw new Error('userId is required');
      }

      const response = await axios.get(
        `${BASE_URL}/${encodeURIComponent(userId.trim())}`,
        {
          headers: Contexture.getHeaders(),
          params,
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async create(profileData, params) {
    try {
      if (
        !profileData.userId ||
        profileData.techStack === undefined ||
        profileData.tools === undefined
      ) {
        throw new Error('userId, techStack, and tools are required');
      }

      const response = await axios.post(`${BASE_URL}`, profileData, {
        headers: {
          ...Contexture.getHeaders(),
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async update(userId, updates, params) {
    try {
      if (!userId || userId.trim().length === 0) {
        throw new Error('userId is required');
      }

      const response = await axios.put(
        `${BASE_URL}/${encodeURIComponent(userId.trim())}`,
        updates,
        {
          headers: {
            ...Contexture.getHeaders(),
            'Content-Type': 'application/json',
          },
          params,
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async delete(userId, params) {
    try {
      if (!userId || userId.trim().length === 0) {
        throw new Error('userId is required');
      }

      const response = await axios.delete(
        `${BASE_URL}/${encodeURIComponent(userId.trim())}`,
        {
          headers: Contexture.getHeaders(),
          params,
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }
}
